/**
 * Simple event bus to replace $root.$emit / $root.$on for cross-component communication
 * Use this instead of Vue's $root event system which can be unreliable in Ionic 7
 */
import { reactive } from 'vue';

const listeners = reactive(new Map());

export const eventBus = {
  /**
   * Emit an event with optional data
   * @param {string} eventName - Name of the event
   * @param {*} data - Data to pass with the event
   */
  emit(eventName, data) {
    console.log(`[DEBUG eventBus] emit: ${eventName}`, data);
    const handlers = listeners.get(eventName) || [];
    handlers.forEach(handler => {
      try {
        handler(data);
      } catch (error) {
        console.error(`[DEBUG eventBus] Error in handler for ${eventName}:`, error);
      }
    });
  },

  /**
   * Subscribe to an event
   * @param {string} eventName - Name of the event
   * @param {Function} handler - Callback function
   * @returns {Function} Unsubscribe function
   */
  on(eventName, handler) {
    console.log(`[DEBUG eventBus] on: ${eventName}`);
    if (!listeners.has(eventName)) {
      listeners.set(eventName, []);
    }
    listeners.get(eventName).push(handler);

    // Return unsubscribe function
    return () => {
      this.off(eventName, handler);
    };
  },

  /**
   * Unsubscribe from an event
   * @param {string} eventName - Name of the event
   * @param {Function} handler - The same handler function passed to on()
   */
  off(eventName, handler) {
    console.log(`[DEBUG eventBus] off: ${eventName}`);
    const handlers = listeners.get(eventName) || [];
    const index = handlers.indexOf(handler);
    if (index > -1) {
      handlers.splice(index, 1);
    }
  },
};

export default eventBus;
